import { ListItem } from '@fs/zion-ui'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { NoticeLoading } from '@fs/zion-icon'
import { removeMemberAsAdmin } from '../../../services/updateMemberStatus'

export default function RemoveAdminListItem({
  groupId,
  memberCisId,
  onRemoveAdmin,
  memberIsSelf,
  adminCount,
  isResearcherTree,
  memberIsSelfOverlay,
  removeAsCoOwnerOverlay,
}) {
  const [t] = useTranslation()
  const [loading, setLoading] = useState(false)
  const isCurrent = useRef(true)

  useEffect(() => {
    isCurrent.current = true
    return () => {
      isCurrent.current = false
    }
  })

  const onClick = (event) => {
    if (memberIsSelf) {
      memberIsSelfOverlay.handleClick(event)
    } else if (isResearcherTree) {
      removeAsCoOwnerOverlay.handleClick(event)
    } else {
      setLoading(true)
      removeMemberAsAdmin(groupId, memberCisId)
        .then(() => onRemoveAdmin())
        .catch(console.error)
        .finally(() => isCurrent.current && setLoading(false))
    }
  }

  const removeTranslationKey = isResearcherTree
    ? 'group-management.remove-co-owner.action'
    : 'group-management.remove-administrator.action'

  return (
    <ListItem
      disabled={loading || adminCount === 1}
      startElement={loading ? <ListItem.Icon Icon={NoticeLoading} /> : undefined}
      primaryText={t(removeTranslationKey)}
      onClick={onClick}
      data-testid={`remove-as-admin-button-${memberCisId}`}
    />
  )
}
